// export const url = "http://localhost:8000/";
// export const url = "http://staging.onefutureplay.com/";//Staging
// export const url = "http://utregseduurzaamheidsspelen.nl/";//Live
//export const url = "https://desterksteschakels.nl/impact/";//Live
//export const url = "https://desterksteschakels.nl/";//Live
// export const url = "https://rwscirculair.nl/";//Live
//export const url = "http://onefutureplay.com/";//Live
// export const url = "http://demo.onefutureplay.com/";//Live
//export const url = "http://roelofskompas.nl/";//Live
export const url = "http://impact.babetteporcelijn.com/";//Live
// export const url = "http://stedinplay.net/";
// export const url = "http://speelermeeruit.nl/";
// export const url = "https://playrail.nl/";
// export const url = "https://aplay.nl/";
// export const url = "https://brenghetsamen.nl/";
//export const url = "";//Local

// export const api_url = "http://localhost:8000/";
// export const api_url = "http://staging.onefutureplay.com/";//Staging
// export const api_url = "http://utregseduurzaamheidsspelen.nl/";//Live
//export const api_url = "https://desterksteschakels.nl/";//Live
// export const api_url = "https://rwscirculair.nl/";//Live
//export const api_url = "http://onefutureplay.com/";//Live
// export const api_url = "http://demo.onefutureplay.com/";//Live
//export const api_url = "http://roelofskompas.com/";//Live
export const api_url = "http://impact.babetteporcelijn.com/";//Live
// export const api_url = "http://stedinplay.net/";
// export const api_url = "http://speelermeeruit.nl/";
// export const api_url = "https://playrail.nl/";
// export const api_url = "https://aplay.nl/";
// export const api_url = "https://brenghetsamen.nl/";

export const dev_env = "production";
// export const dev_env = "local";

// export const lang = "NL";
export const lang = "EN";
// export const lang = "FR";


// WEBPACK FOOTER //
// ./src/const/base.js